// Shapes
import { MessageShape } from "~shapes/message"

export const isMessageActive = (message: MessageShape): boolean => {
  return message.status.toLowerCase() === "active"
}
